import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { SamplesService } from '../../../samples/service/samples.service';
import { FinalisationReport } from '../finalisation-report/finalisation-report.component';

export interface SubmitSampleDialogData {
  sampleId: string;
  onConfirm: () => void;
}

@Component({
  standalone: true,
  imports: [AsyncPipe, FinalisationReport, MatButton, MatDialogModule, MatProgressSpinner],
  templateUrl: './submit-sample-dialog.component.html',
})
export class SubmitSampleDialogComponent {
  private readonly dialogData = inject<SubmitSampleDialogData>(MAT_DIALOG_DATA);
  private readonly sampleService = inject(SamplesService);

  readonly checks = this.sampleService
    .checkSubmission(this.dialogData.sampleId)
    .catch((e) => e.error.message);

  readonly checksValid = this.checks.then((checks) => checks.every(([valid]) => valid !== 'ERR'));

  submitting = false;

  submit() {
    this.submitting = true;
    this.sampleService
      .submit(this.dialogData.sampleId)
      .then(() => this.dialogData.onConfirm())
      .finally(() => (this.submitting = false));
  }

  cancel() {
    this.sampleService.unsubmit(this.dialogData.sampleId);
  }
}
